<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_edit_notify_mail_info'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form class="dialog-form-item" label-width="170px">
                        <!--- メールアドレス --->
                        <el-form-item ref="email" prop="email">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_tenant_email'"/> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start" >
                                    <div slot="content" style="text-align:left" v-t="'message.hint_notify_email_input'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="email" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.email.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- 担当者名 --->
                        <el-form-item ref="displayName" prop="displayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_contact_name'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_notify_user_input'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- 契約の通知 --->
                        <el-form-item ref="notifyContract" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_notify_contract'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_notify_mail_contract'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="inputForm.notifyContract.value" active-color="#5171cb" @change="handleChangeNotifyMail()"></el-switch>
                        </el-form-item>
                        <!--- システムの通知 --->
                        <el-form-item ref="notifySystem" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_notify_maintenance'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_notify_mail_system'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="inputForm.notifySystem.value" active-color="#5171cb" @change="handleChangeNotifyMail()"></el-switch>
                        </el-form-item>
                        <!--- システムの通知 --->
                        <el-form-item ref="notifySystem" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_notify_service_failure'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_notify_mail_failure'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="inputForm.notifyServiceFailure.value" active-color="#5171cb" @change="handleChangeNotifyMail()"></el-switch>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <span v-if="!inputForm.notifyContract.value && !inputForm.notifySystem.value && !inputForm.notifyServiceFailure.value" style="color:#f56c6c;font-size:12px;padding-right:25px" v-t="'message.error_notify_mail_unselected'">
                    </span>
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="updateNotificationMail" :disabled="disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    props: [ 'notificationMailInfo' ],
    data() {
        return {
            inputForm: {
                email:                 { validationRule: "userEmailAddress", valid: true,    value: null,   isComposing: false },
                displayName:           { validationRule: "reqDisplayName",   valid: true,    value: null,   isComposing: false },
                notifyContract:        { validationRule: "none",             valid: true,    value: true,   isComposing: false },
                notifySystem:          { validationRule: "none",             valid: true,    value: true,   isComposing: false },
                notifyServiceFailure:  { validationRule: "none",             valid: true,    value: true,   isComposing: false },
                notifyAutoNotice:      { validationRule: "none",             valid: true,    value: false,  isComposing: false },
            },
            disableButton: true,
        };
    },
    created: function() {
        this.inputForm.email.value = this.notificationMailInfo.email;
        this.inputForm.displayName.value = this.notificationMailInfo.userName;
        this.inputForm.notifyContract.value = this.notificationMailInfo.notifyContract;
        this.inputForm.notifySystem.value = this.notificationMailInfo.notifySystem;
        this.inputForm.notifyServiceFailure.value = this.notificationMailInfo.notifyServiceFailure;
    },
    methods: {
        updateNotificationMail: function() {
            this.$emit('update', {
                        email: this.inputForm.email.value,
                        displayName: this.inputForm.displayName.value,
                        notifyContract: this.inputForm.notifyContract.value,
                        notifySystem: this.inputForm.notifySystem.value,
                        notifyServiceFailure: this.inputForm.notifyServiceFailure.value,
                        userType: constants.DESTINATION_TYPE_END_USER
            });
        },
        handleChangeNotifyMail() {
            if ((!this.inputForm.notifyContract.value) && (!this.inputForm.notifySystem.value) && (!this.inputForm.notifyServiceFailure.value)) {
                this.inputForm["notifyContract"].valid = false;
                this.inputForm["notifySystem"].valid = false;
                this.inputForm["notifyServiceFailure"].valid = false;
            } else {
                this.inputForm["notifyContract"].valid = true;
                this.inputForm["notifySystem"].valid = true;
                this.inputForm["notifyServiceFailure"].valid = true;
            }
            this.setButtonStatus();
        },
        setButtonStatus: function() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult;
            validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
    },
    watch: {
    },
    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    }
}
</script scoped>

<style scoped>
</style>
